module.exports = __webpack_public_path__ + "static/media/overlay-darkgrey.8407419b.png";